export function SubscribeFlowBg() {
  return (
    <svg
      width="1200"
      height="900"
      viewBox="0 0 1200 900"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18_1590)">
        <path
          d="M0 900L1200 900V0L0 0V900Z"
          fill="url(#paint0_linear_18_1590)"
        />
        <path
          d="M0 900L1200 900V0L0 0V900Z"
          fill="url(#paint1_linear_18_1590)"
        />
        <g filter="url(#filter0_f_18_1590)">
          <path
            d="M277.77 513.15C265.03 516.17 251.78 510.75 244.79 499.67L208.54 442.17L151.04 478.42C148.16 480.23 145.04 481.55 141.76 482.33C129.02 485.35 115.77 479.93 108.78 468.85C99.77 454.56 104.07 435.6 118.36 426.59L175.86 390.34L139.61 332.84C135.25 325.92 133.84 317.71 135.65 309.73C137.46 301.75 142.27 294.95 149.19 290.59C152.07 288.78 155.19 287.46 158.47 286.69C171.21 283.67 184.46 289.09 191.45 300.17L227.7 357.67L285.2 321.42C288.08 319.61 291.2 318.29 294.48 317.52C307.22 314.5 320.47 319.92 327.46 331C331.82 337.92 333.23 346.13 331.42 354.11C329.61 362.09 324.8 368.89 317.88 373.25L260.38 409.5L296.63 467C300.99 473.92 302.4 482.13 300.59 490.11C298.78 498.09 293.97 504.89 287.05 509.25C284.17 511.06 281.05 512.38 277.77 513.15Z"
            fill="url(#paint2_linear_18_1590)"
          />
        </g>
        <g filter="url(#filter1_f_18_1590)">
          <path
            d="M-70.93 98.78C-66.03 100.34 -61.1 101.52 -56.18 102.32C-62.43 140.8 -39.73 179.09 -1.46004 191.3C40.32 204.63 84.96 181.85 98.78 140.37C103.95 142.21 109.25 143.81 114.69 145.14C200.61 166.15 287.29 113.52 308.3 27.6C329.31 -58.32 276.69 -145.01 190.77 -166.02C119.97 -183.33 48.65 -150.65 13.99 -90.54C7.33996 -94.47 0.15996 -97.72 -7.51004 -100.16C-62.44 -117.68 -121.17 -87.35 -138.68 -32.42C-156.2 22.51 -125.87 81.25 -70.94 98.76L-70.93 98.78Z"
            fill="url(#paint3_linear_18_1590)"
          />
        </g>
        <g filter="url(#filter2_f_18_1590)">
          <path
            d="M1060.21 156.88C1066.92 156.66 1073.5 155.96 1079.91 154.8C1089.02 204.88 1133.66 242.1 1186.09 240.42C1243.32 238.58 1288.31 191.06 1287.22 133.99C1294.39 133.99 1301.61 133.65 1308.88 132.91C1423.78 121.26 1507.48 18.6601 1495.82 -96.2499C1484.17 -211.15 1381.58 -294.86 1266.68 -283.21C1171.99 -273.61 1098.5 -202.25 1082.09 -113.16C1072.19 -115.1 1061.94 -115.96 1051.43 -115.62C976.19 -113.2 917.16 -50.2399 919.58 25.0001C922 100.24 984.96 159.28 1060.21 156.86V156.88Z"
            fill="url(#paint4_linear_18_1590)"
          />
        </g>
        <g opacity="0.6" filter="url(#filter3_f_18_1590)">
          <path
            d="M961.82 455.62L849.45 598.86C841.95 608.42 852.24 621.65 863.36 616.72L961.62 573.15C963.06 572.51 964.74 573.1 965.47 574.49L985.53 612.55C1000.19 640.37 1038.64 643.85 1058.06 619.12L1159.8 489.51C1167.31 479.94 1156.99 466.7 1145.88 471.65L1045.04 516.58C1043.57 517.23 1041.85 516.61 1041.15 515.17L1014.63 461.16C1004.45 440.42 976.09 437.45 961.83 455.63L961.82 455.62Z"
            fill="url(#paint5_linear_18_1590)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_18_1590"
          x="94.068"
          y="275.863"
          width="248.121"
          height="248.114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_18_1590"
          />
        </filter>
        <filter
          id="filter1_f_18_1590"
          x="-158.644"
          y="-185.64"
          width="486.565"
          height="395.748"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="7.5"
            result="effect1_foregroundBlur_18_1590"
          />
        </filter>
        <filter
          id="filter2_f_18_1590"
          x="901.508"
          y="-302.292"
          width="613.396"
          height="560.767"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="9"
            result="effect1_foregroundBlur_18_1590"
          />
        </filter>
        <filter
          id="filter3_f_18_1590"
          x="836.889"
          y="433.626"
          width="335.473"
          height="212.094"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_18_1590"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18_1590"
          x1="626.08"
          y1="-0.720016"
          x2="575.27"
          y2="877.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#00293F" />
          <stop offset="0.55" stopColor="#00283E" stopOpacity="0.97" />
          <stop offset="0.71" stopColor="#00263B" stopOpacity="0.86" />
          <stop offset="0.82" stopColor="#002335" stopOpacity="0.67" />
          <stop offset="0.91" stopColor="#001E2D" stopOpacity="0.41" />
          <stop offset="0.99" stopColor="#001923" stopOpacity="0.07" />
          <stop offset="1" stopColor="#001822" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18_1590"
          x1="534.2"
          y1="653.16"
          x2="744.67"
          y2="3.29999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00324E" stopOpacity="0" />
          <stop offset="0.34" stopColor="#004C59" stopOpacity="0.37" />
          <stop offset="0.78" stopColor="#006D68" stopOpacity="0.82" />
          <stop offset="1" stopColor="#007A6E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18_1590"
          x1="-51.4268"
          y1="362.825"
          x2="558.399"
          y2="446.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002C42" stopOpacity="0" />
          <stop offset="0.34" stopColor="#003650" stopOpacity="0.22" />
          <stop offset="1" stopColor="#00496B" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_18_1590"
          x1="-29.57"
          y1="-10.8"
          x2="481.14"
          y2="86.38"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00374B" stopOpacity="0.05" />
          <stop offset="0.08" stopColor="#003F51" stopOpacity="0.08" />
          <stop offset="0.65" stopColor="#007274" stopOpacity="0.24" />
          <stop offset="1" stopColor="#008582" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_18_1590"
          x1="1395.9"
          y1="-106.33"
          x2="860.44"
          y2="155.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#003F50" stopOpacity="0" />
          <stop offset="0.57" stopColor="#007674" stopOpacity="0.22" />
          <stop offset="1" stopColor="#00A593" stopOpacity="0.4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_18_1590"
          x1="1029.76"
          y1="641.35"
          x2="970.35"
          y2="411.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#004C66" stopOpacity="0" />
          <stop offset="0.01" stopColor="#004C65" stopOpacity="0" />
          <stop offset="0.65" stopColor="#005660" stopOpacity="0.36" />
          <stop offset="1" stopColor="#005A5E" stopOpacity="0.5" />
        </linearGradient>
        <clipPath id="clip0_18_1590">
          <rect width="1200" height="900" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
